import { ThunkAction } from 'redux-thunk';
import { StoreState } from '..';
import { DashboardActionTypes } from './dashboardTypes';
import apiRest from '../../services/apiRest';
import errorHandler from '../../errorHandler';
import { Action } from 'redux';
import { addSnackbar } from '../snacks/snacksActions';

export function getPanelsData():
ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch) => {
    try {
      dispatch({
        type: DashboardActionTypes.GET_PANELS_DATA_START,
      });
      const { data: panelsData } = await apiRest.get('/dashboard');
      dispatch({
        type: DashboardActionTypes.GET_PANELS_DATA_SUCCESS,
        panelsData,
      });
    } catch (e) {
      errorHandler(e);
      dispatch({ type: DashboardActionTypes.GET_PANELS_DATA_ERROR });
      dispatch( addSnackbar('Houve um problema. Verifique sua conexão com a internet e atualize a página', { variant: 'error' }));
    }
  };
}
